export default __webpack_public_path__ + "static/media/logot.0cee123a.png";